import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: "/atlas" // https://router.vuejs.org/api/#base
});
export default router;

// BIG FIXME! Man nepatinka, kad base'as dubliuojasi čia ir vue.config.js faile! To neturi būti...